import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Table } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom'
import Routes from '../../../routes'
import { MdCheck } from '@react-icons/all-files/md/MdCheck'
import { MdClose } from '@react-icons/all-files/md/MdClose'

const styles = StyleSheet.create({
    title: {
        color: '#193f83',
        fontWeight: 700
    },
    titleTh: {
        color: '#193f83',
        fontWeight: 700,
        fontSize: '21px',
        padding: '40px 10px',
        backgroundColor: '#F5F7F9',
        width: '30%'
    },
    th40: {
        width: '40%'
    },
    checkIcon: {
        fontSize: '50px',
        color: '#06A77D'
    },
    closeIcon: {
        fontSize: '50px',
        color: '#A70630'
    },
    center: {
        textAlign: 'center'
    },
    vCenter: {
        verticalAlign: 'middle'
    },
    cta: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '10px 30px',
        fontWeight: '700',
        fontSize: '19px',

    },
    highlight: {
        backgroundColor: '#78bfe0',
        fontWeight: 300,
        padding: '2px'
    },
    bold: {
        fontWeight: '900'
    }
});


function mapStateToProps(state) {
    return {

    };
}

class Comparacion extends Component {
    render() {
        return (
            <Container  >

                <Row className="my-3">
                    <Col>
                        <h2 className={css(styles.title) + " text-center my-5"}>
                            Ahorra dinero, despídete de tu minibodega.
                        </h2>
                        <p className="lead text-center mt-5 mb-1">
                            Prueba Mubit.co hoy, recibe un <b className={css(styles.bold)}>descuento</b> al instante.
                        </p>
                        <p className="lead text-center mb-5">
                            Almacena tus cosas de forma inteligente y segura ahorrando hasta 40% de lo que gastas en una minibodega.
                        </p>
                    </Col>
                </Row>

                <Row className="my-2">
                    <Col>
                        <Table bordered responsive>
                            <thead>
                                <tr>
                                    <th className={css(styles.vCenter, styles.center, styles.titleTh, styles.th40)}>Beneficios</th>
                                    <th className={css(styles.vCenter, styles.center, styles.titleTh)}>Minibodega</th>
                                    <th className={css(styles.vCenter, styles.center, styles.titleTh)}>Mubit.co</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr >
                                    <td className={css(styles.vCenter, styles.center)}>Almacenaje</td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)} /></td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)} /></td>
                                </tr>
                                <tr >
                                    <td className={css(styles.vCenter, styles.center)}>Recolección y entrega a Domicilio</td>
                                    <td className={css(styles.center, styles.vCenter)}><MdClose className={css(styles.closeIcon)} /></td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)} /></td>
                                </tr>
                                <tr >
                                    <td className={css(styles.vCenter, styles.center)}>Emplayado y protección para tus bienes</td>
                                    <td className={css(styles.center, styles.vCenter)}><MdClose className={css(styles.closeIcon)} /></td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)} /></td>
                                </tr>
                                <tr >
                                    <td className={css(styles.vCenter, styles.center)}>Acceso a tus pertenencias en un sólo clic</td>
                                    <td className={css(styles.center, styles.vCenter)}><MdClose className={css(styles.closeIcon)} /></td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)} /></td>
                                </tr>
                                <tr >
                                    <td className={css(styles.vCenter, styles.center)}>Inventario electrónico con fotografías</td>
                                    <td className={css(styles.center, styles.vCenter)}><MdClose className={css(styles.closeIcon)} /></td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)} /></td>
                                </tr>
                                <tr >
                                    <td className={css(styles.vCenter, styles.center)}>Paga sólo los metros que usas</td>
                                    <td className={css(styles.center, styles.vCenter)}><MdClose className={css(styles.closeIcon)} /></td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)} /></td>
                                </tr>
                                <tr >
                                    <td className={css(styles.vCenter, styles.center)}>Sin depósitos</td>
                                    <td className={css(styles.center, styles.vCenter)}><MdClose className={css(styles.closeIcon)} /></td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)} /></td>
                                </tr>
                                {/* <tr >
                                    <td className={css(styles.vCenter,styles.center)}>Acceso en persona dentro de la bodega.</td>
                                    <td className={css(styles.center, styles.vCenter)}><MdCheck className={css(styles.checkIcon)}/></td>
                                    <td className={css(styles.center, styles.vCenter)}><MdClose className={css(styles.closeIcon)}/></td>
                                </tr> */}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                {/* <Row className="my-5">
                    <Col className="d-flex justify-content-center">
                        <a href={Routes.NewRequest.url+"?from=saber-mas"} className={css(styles.cta)+""}>Saber más</a>
                    </Col>
                </Row> */}
            </Container>
        );
    }
}

export default connect(
    mapStateToProps,
)(Comparacion);